import {
  JOB_COMPLETED_REQUEST,
  JOB_COMPLETED_SUCCESS,
} from '../../constants/ActionTypes'

import { BroadcastingApi } from "../api/BroadcastingApi.js";

export const jobCompletedRequest = () => ({
  type: JOB_COMPLETED_REQUEST,
});

const jobCompletedSuccess = (e) => ({
  type: JOB_COMPLETED_SUCCESS,
  payload: {
    message: e.message,
  }
});

export function jobCompleted(userId) {
  return async (dispatch) => {
    BroadcastingApi.buildEcho()
      .private(`job-completed.${userId}`)
      .listen('.job.completed', (e) => {
        dispatch(jobCompletedSuccess(e));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/Broadcasting.js